module.exports = __webpack_public_path__ + "fonts/montserrat-v30-latin-500.bb986b8.woff2";